import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const openPencilHistory = createAction(types.OPEN_PENCIL_HISTORY);
export const closePencilHistory = createAction(types.CLOSE_PENCIL_HISTORY);

export const offerHistoryRequest = createAction(types.OFFERHISTORY_REQUEST);
export const offerHistorySuccess = createAction(types.OFFERHISTORY_SUCCESS);
export const offerHistoryFailure = createAction(types.OFFERHISTORY_FAILURE);

export const versionSnapshotsRequest = createAction(
  types.VERSIONSNAPSHOTS_REQUEST,
);
export const versionSnapshotsSuccess = createAction(
  types.VERSIONSNAPSHOTS_SUCCESS,
);
export const versionSnapshotsFailure = createAction(
  types.VERSIONSNAPSHOTS_FAILURE,
);

export const restoreVersionRequest = createAction(types.RESTOREVERSION_REQUEST);
export const restoreVersionSuccess = createAction(types.RESTOREVERSION_SUCCESS);
export const restoreVersionFailure = createAction(types.RESTOREVERSION_FAILURE);

export default {
  openPencilHistory,
  closePencilHistory,
  offerHistoryRequest,
  offerHistorySuccess,
  offerHistoryFailure,
  versionSnapshotsRequest,
  versionSnapshotsSuccess,
  versionSnapshotsFailure,
  restoreVersionRequest,
  restoreVersionSuccess,
  restoreVersionFailure,
};
